import type { PdpVariant } from "../utils/pricing";
import "./ProductVariantSelect.css";

type ProductVariantSelectProps = {
  ariaLabel?: string;
  className?: string;
  optionLabel: (variant: PdpVariant) => string;
  onChange: (variantId: string) => void;
  selectedVariantId: string;
  variants: PdpVariant[];
};

export function ProductVariantSelect({
  ariaLabel = "Produktvariante",
  className,
  onChange,
  optionLabel,
  selectedVariantId,
  variants,
}: ProductVariantSelectProps) {
  return (
    <div
      className={`react-pdp__onetime-variant-select-wrap${className ? " " + className : ""}`}
    >
      <select
        aria-label={ariaLabel}
        className="react-pdp__onetime-variant-select"
        onChange={(event) => onChange(event.currentTarget.value)}
        value={selectedVariantId}
      >
        {variants.map((variant) => (
          <option key={variant.variantId} value={variant.variantId}>
            {optionLabel(variant)}
          </option>
        ))}
      </select>
    </div>
  );
}
